import {AnyAction, createReducer} from '@reduxjs/toolkit'
import {SET_BASE_ENVIRONMENT_OLD, setBaseEnvironment, setFormFactor} from '../actions/environment'
import {EnvironmentConfig} from '../types/state'

const defaultState: EnvironmentConfig = {} as EnvironmentConfig

export const environment = createReducer(defaultState, builder => {
  builder
    .addCase(setBaseEnvironment.fulfilled, (state, action) => {
      return {...state, ...action.payload}
    })
    .addCase(setFormFactor, (state, action) => {
      return {...state, mobile: action.payload}
    })
    .addCase(SET_BASE_ENVIRONMENT_OLD, (state, action: AnyAction) => {
      return {...state, ...action.payload}
    })
})
